import React from "react";
import PropTypes from "prop-types";
import { FormGroup, FormControl } from "react-bootstrap";
import {injectIntl, intlShape} from 'react-intl';
import { getDecimalSeperator } from "../lng/Locales";
import { formatValue, unformatValue } from "./GrafikenCommon"

class FormSetNumber extends React.Component {
	constructor(props, context) {
		super(props, context);

		this.handleChange = this.handleChange.bind(this);
		this.handleKeyPress = this.handleKeyPress.bind(this);

		this.state = {
			lastLocale: this.props.intl.locale,
			externValue: null,
			value: '',
			valid: "error"
		};
	}

	stringToFloat (str) {
		let stringWithProperDecimalSeperator = str.replace(',', '.');
		let stringWithValidNegativeNumber = stringWithProperDecimalSeperator.replace('-', '-0'); // this is needed to parse a string with only a '-' as valid number
		return parseFloat(stringWithValidNegativeNumber);
	}

	isCharAllowed(char) {
		const allowedChars = ['-', '0', '1', '2', '3', '4', '5', '6', '7', '8', '9', getDecimalSeperator(this.props.intl.locale)];
		let match = false;
		for(let i = 0; i < allowedChars.length; ++i) {
			if(allowedChars[i] === char) {
				match = true;
			}
		}
		return match;
	}

	isStringANumber (input) {

		// check minimum length of string
		const length = input.length;
		if (length === 0) {
			return false;
		}

		// check, that only allowed chars are used
		for(let i = 0; i < input.length; ++i) {
			if(this.isCharAllowed(input[i]) === false) {
				return false;
			}
		}

		// check, if number
		let n = this.stringToFloat(input);
		if (isNaN(n)) {
			return false;
		}
	
		return true;
	}

	isInRange(newValue) {
		const range = this.props.validRange;
		if (newValue === null || newValue === undefined) {
			return false;
		}
		else {
			let valueTooLow = false;
			if (range[0] === null || range[0] === undefined) {
				valueTooLow = false;
			}
			else {
				let rangeLowerEnd = range[0];
				if(newValue <= rangeLowerEnd) {
					valueTooLow = true;
				}
				else {
					valueTooLow = false;
				}
			}
			
			let valueTooHigh = false;
			if(range[1] === null || range[1] === undefined) {
				valueTooHigh = false;
			}
			else {
				let rangeUpperEnd = range[1];
				if(newValue >= rangeUpperEnd) {
					valueTooHigh = true;
				}
				else {
					valueTooHigh = false;
				}
			}

			if(valueTooLow || valueTooHigh) {
				return false;
			}	
		}
		return true;
	}

	handleChange(e) {
		const oldValue = this.state.value;
		
		// remove all disallowed chars
		let newValue = "";
		for(let i = 0; i < e.target.value.length; ++i) {
			if(this.isCharAllowed(e.target.value[i])) {
				newValue += e.target.value[i];
			}
		}

		// set next value
		let nextValue;
		if(newValue === null || newValue === undefined || newValue === "") {
			nextValue = newValue;
		}
		else if(this.isStringANumber(newValue)) {
			nextValue = newValue;
		}
		else {
			nextValue = oldValue;
		}

		// set next valid
		let nextValid;
		if(this.isStringANumber(nextValue)) {
			let number = this.stringToFloat(newValue);
			let numberBase = unformatValue(number, this.props.y_value, this.props.units);
			if(this.isInRange(numberBase)) {
				nextValid = null;
			}
			else {
				nextValid = 'error';
			}
		}

		this.setState({
			externValue: this.props.externValue,
			value: nextValue,
			valid: nextValid
		});
	}

	commitValue(newValue) {
		let number = this.stringToFloat(newValue);
		let numberBase = unformatValue(number, this.props.y_value, this.props.units);
		if(this.isInRange(numberBase)) {
			this.props.doIfValid(numberBase);
		}
	}

	handleKeyPress(e) {
		if (e.charCode === 13) { // wenn Eingabe-Taste gedrückt
			if(this.state.valid === null) { // wenn Status ok
				this.commitValue(this.state.value);
			}
		}
	}

	updateStateWithExternValueSilently() {
		// disable eslint warnings for the next lines because of warning: "react/no-direct-mutation-state"
		// eslint-disable-next-line
		this.state.lastLocale = this.props.intl.locale; 
		// eslint-disable-next-line
		this.state.externValue = this.props.externValue;
		// eslint-disable-next-line
		this.state.value = formatValue(this.state.externValue, this.props.y_value, this.props.units, this.props.intl);
		// eslint-disable-next-line
		this.state.valid = null;
	}

	render() {

		if(
			(this.state.externValue !== this.props.externValue) || // this.props.externValue hat sich wohl extern von selbst geändert
			(this.state.lastLocale !== this.props.intl.locale)     // sprache wurde wohl verstellt
		){
			this.updateStateWithExternValueSilently();
		}

		return (
			<FormGroup
				validationState={this.state.valid}
			>
				<FormControl
					bsClass={ (this.state.valid === null) ? 'Y-Limit-Valid' : 'Y-Limit-Not-Valid' }
					type="text"
					value={this.state.value}
					placeholder="---"
					onChange={this.handleChange}
					onKeyPress={this.handleKeyPress}
				/>
			</FormGroup>
		);
	}
}

FormSetNumber.propTypes = {
	intl: intlShape.isRequired,
	externValue: PropTypes.number,
	validRange: PropTypes.array.isRequired,
	y_value: PropTypes.object.isRequired,
	units: PropTypes.object.isRequired,
	doIfValid: PropTypes.func.isRequired
};

export default injectIntl(FormSetNumber);